import Button from '../button/index.vue';
import { reactive, computed } from 'vue';
export default {
  name: 'tableinfo',
  components: {
    Button
  },
  props: {
    totalCol: {   //計算column的長度要跟原本table對齊
      type: [String, Number],
      required: false,
    },
    custom: {
      type: String,
      required: false,
    },
    data: {
      type: Array,
      required: false,
      default: [
        {
          brightness: '120 nt/m2',
          colorTemperature: '6500K',
          gamma: '2.2',
        }
      ],
    },
    columns: {
      type: Array,
      required: false,
      default: [

        {
          title: "Brightness",
          key: "brightness",
        },
        {
          title: "Color Temperature",
          key: "colorTemperature"
        },
        {
          title: "Gamma",
          key: "gamma",
        }
      ],
    },
    wdCustom: {    // for custom width 
      type: String,
      default: 'default',
    }
  },
  setup(props) {
    const state = reactive({
      allCheck: false,
      dataCheck: [],
      mainSelect: '',
      isExtend: [],
      taleExtend: [],
    })



    const emptyTr = computed(() => {
      let empty = 0
      if (props.checkBox || props.dropdown) {
        empty = 1
      }
      if (props.checkBox && props.dropdown) {
        empty = 2
      }
      return empty
    }
    )

    const extend = (i) => {
      state.taleExtend[i] = !state.taleExtend[i]
    }

    // const classStyle = computed(() => [
    //   {
    //     'style--has-text': text != ''
    //   },
    //   'style--' + layout,
    //   'style--' + size,
    // ])


    return {
      state,
      extend,
      emptyTr,
    }
  }// end: setup
}


